import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Plan sheet provider toggle: the card (web checkout) segment's label.
export default class CardText extends BaseOption {
  static userInterfaceComponent = {
    label: "Card Label",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "Card";
}
